import React from 'react';
import { CellText } from '@opendate-app/setlist';
import ReportingGiftCardsReportPage, { formatCents, centsKpiCard, countKpiCard } from './ReportingGiftCardsReportPage';
import {
  GIFT_CARD_SALES_COLUMNS, SORT_TYPES, defaultVisibleColumns, defaultHiddenColumns,
} from '../constants/giftCardsColumnsConfig';

const SALES_CONFIG = {
  pageTitle: 'Gift Card Sales',
  pageSubtitle: 'Gift cards issued in the selected range by product and channel. Money totals count paid sales only; complimentary and imported cards are listed but not counted as sales. Your Net is what the sales pay you after your share of refunds. Refunds count on the day they were issued; refunds that failed at Stripe are left out.',
  sidebarKey: 'gift_cards_sales',
  defaultPreset: 'year_to_date',
  dateModeOptions: [{ key: 'order_date', label: 'Issued Date' }],
  defaultSortRules: [{ field: 'face_value_cents', direction: 'desc' }],

  columns: GIFT_CARD_SALES_COLUMNS,
  sortTypes: SORT_TYPES,
  getDefaultVisibleColumns: defaultVisibleColumns(GIFT_CARD_SALES_COLUMNS),
  getDefaultHiddenColumns: defaultHiddenColumns(GIFT_CARD_SALES_COLUMNS),
  localStorageKey: (teamId) => `reportingGiftCardsSalesColumns_${teamId}`,
  firstColumnId: 'product_name',

  detailErrorMessage: 'Failed to load gift card sales.',
  detailTableTitle: 'Sales by Product and Channel',
  emptyMessage: 'No gift cards were issued in this range.',
  searchPlaceholder: 'Search products...',

  buildKpiCards: (current, prior) => [
    countKpiCard('Cards Sold', 'cards_sold', current, prior),
    centsKpiCard('Face Value Sold', 'face_value_cents', current, prior),
    centsKpiCard('Your Fees', 'organizer_fees_cents', current, prior),
    centsKpiCard('Your Net', 'net_cents', current, prior),
    centsKpiCard('Opendate & Processing Fees', 'opendate_fees_cents', current, prior),
    centsKpiCard('Refunded to Buyers', 'refunds_cents', current, prior),
    countKpiCard('Issued, Not Sold', 'cards_issued_not_sold', current, prior),
    centsKpiCard('Issued, Not Sold Value', 'issued_not_sold_face_value_cents', current, prior),
  ],

  renderCellValue: (col, row) => {
    switch (col.id) {
      case 'product_name': return row.product_name;
      case 'channel_label': return row.channel_label;
      case 'cards': return (row.cards || 0).toLocaleString();
      case 'net_cents': return <CellText primary={formatCents(row.net_cents)} />;
      default: return formatCents(row[col.id]);
    }
  },
};

function ReportingGiftCardsSalesPage(props) {
  return (
    <ReportingGiftCardsReportPage
      {...props}
      report="sales"
      filterIds={['gift_card_product_id', 'channel']}
      config={SALES_CONFIG}
    />
  );
}

export default ReportingGiftCardsSalesPage;
